import { GetterTree } from 'vuex'
import { Persons, CurrentPerson } from './types'
import { RootState } from '../types'

export const getters: GetterTree<Persons, RootState> = {
  getThingsAssignments: state => {
    return state.thingsAssignments
  },
  getPersons: state => {
    return state.filterPersons.filter((obj, index) => {
      return index === state.filterPersons.findIndex(o => obj.id === o.id)
    })
  },
  getCurrentPerson: state => {
    return state.currentPerson
  },
  hasPersons: state => {
    return state.persons.length > 0
  },
  getResponseError: state => {
    return state.responseError
  },
  getResponseMessage: state => {
    return state.responseMessage
  },
  getPersonProfile: state => {
    const currentPerson = state.currentPerson as CurrentPerson
    if (!currentPerson.profile) return ''

    const profile = currentPerson.profile

    const hasProfile = profile.find(p => p.hasOwnProperty('user')) ?? {
      user: ['']
    }

    return hasProfile.user[0]
  },
  getPersonRole: state => {
    const currentPerson = state.currentPerson as CurrentPerson

    if (!currentPerson.roles) return []

    const roles = currentPerson.roles

    if (Object.keys(roles).length > 0) return roles
    else return []
  },
  getPhones: state => {
    const currentPerson = state.currentPerson as CurrentPerson
    return currentPerson.phones.sort((a, b) => a.index - b.index)
  },
  getIbutton: state => {
    const currentPerson = state.currentPerson as CurrentPerson
    return currentPerson.ibutton
  }
}
